export function showSelectDropdownListFooter({ Footer, options }) {
  return Footer && options?.length > 0
}

export function showSelectDropdownListHeader({ Header }) {
  return !!Header
}
